'use client';

import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/navigation';
import { Button } from '@/components/ui/button';

/**
 * Branded, localized 404. Replaces Next.js' default unstyled "This page
 * could not be found." for any unmatched route under a locale. Rendered
 * inside [locale]/layout, so the NextIntlClientProvider + theme are present.
 */
export default function NotFound() {
    const t = useTranslations('common');

    return (
        <div className="flex min-h-[70vh] flex-col items-center justify-center px-6 text-center">
            <p className="text-6xl font-bold tracking-tight text-foreground">404</p>
            <h1 className="mt-4 text-xl font-semibold text-foreground">
                {t('pageNotFound')}
            </h1>
            <p className="mt-2 max-w-md text-sm text-muted-foreground">
                {t('pageNotFoundDescription')}
            </p>
            <Button className="mt-6" render={<Link href="/" />}>
                {t('goHome')}
            </Button>
        </div>
    );
}
